export default __webpack_public_path__ + "static/media/img-0800-greece-half-face.cf009125.png";